var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-of-main-section parallax",style:('background-image: url('+"" + _vm.parallaxImage+');')},[_c('div',{staticClass:"header-text"},[_vm._t("p-1")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }